import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {RolePermission} from '../../models/security/rolepermission';
import {Router} from '@angular/router';
const apiUrl = `${environment.apiUrl}/api/security/rolepermission`;
@Injectable({
  providedIn: 'root'
})
export class RolePermissionService {
  constructor(public httpService: HttpClient,
              private router: Router) { }
  public getAllByRoleId(id: number, permissionId: number): Observable<RolePermission[]> {
    return this.httpService.get<RolePermission[]>(`${apiUrl}/getallbyroleid?id=${id}&mid=${permissionId}`).pipe(
      map(data => data.map(data => new RolePermission().deserialize(data)))
    );
  }
  public getAll(): Observable<RolePermission[]> {
    return this.httpService.get<RolePermission[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new RolePermission().deserialize(data)))
    );
  }
  public add(params: Object): Observable<RolePermission>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new RolePermission().deserialize(data)));

  }
  public update(params: Object): Observable<RolePermission>
  {
    return this.httpService.post(`${apiUrl}/update`, params).pipe(
      map(data => new RolePermission().deserialize(data)));

  }

  public getById(id: number): Observable<RolePermission>
  {
    return this.httpService.get<RolePermission>(`${apiUrl}/findbyid/${id}`).pipe(
      map(data => new RolePermission().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  public addMulti(id: number, moduleId: number, pids: string): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/addmulti?id=${id}&mid=${moduleId}&pids=${pids}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('insert error'))
    );
  }

  public checkPermissionByModule(staffId: number, module: string) : Observable<RolePermission[]> {
    return this.httpService.get<RolePermission[]>(`${apiUrl}/checkpermissionbycodes?stid=${staffId}&mid=${module}`).pipe(
      map(data => data.map( data => new RolePermission().deserialize(data)))
    );
  }
  public checkPermissionByCode(staffId: number, module: string, action: string) {
    return this.httpService.get<boolean>(`${apiUrl}/checkpermissionbycode?stid=${staffId}&mid=${module}&ac=${action}`).pipe(
      map(data => data)
    );
  }
  public checkNavByCode(staffId: number, code: string) {
    return this.httpService.get<boolean>(`${apiUrl}/checknavbycode?stid=${staffId}&code=${code}`).pipe(
      map(data => data)
    );
  }
  public redirectAccesDenied()
  {
    this.router.navigate(['/permission/accessdenied']);
  }
}
